import React, { Fragment } from "react";
import { Query } from "react-apollo";
import { Flex, Box } from "grid-styled";
import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import { validate as buildValidations } from "validate-redux-form";
import { notEmpty } from "../utils/validation";
import moment from "moment";
import { InputContainer, Select, DatePicker } from "./forms";
import JobContractsQuery, { fragments } from "../queries/JobContracts";
import { formatPrice } from "../utils/helpers";
import Button from "./Button";
import ButtonToolbar from "./ButtonToolbar";
import FilePreview from "./FilePreview";
import { CONTRACT_TYPES } from "../constants";

const validate = (values, { attachmentType, contractId }) => {
  let errors = buildValidations(values, {
    name: notEmpty()("Please provide a name."),
    attachmentType: notEmpty()("Please provide an attachment type.")
  });

  if (attachmentType === "CONTRACT") {
    errors = {
      ...errors,
      ...buildValidations(values, {
        contractId: notEmpty()("Please choose a contract.")
      })
    };

    if (contractId === "new") {
      errors = {
        ...errors,
        ...buildValidations(values, {
          contractNumber: notEmpty()("Please provide contract number."),
          contractAmount: notEmpty()("Please provide contract amount."),
          contractEffectiveDate: notEmpty()(
            "Please provide contract effective date."
          ),
          contractType: notEmpty()("Please provide contract type.")
        })
      };
    }
  }

  return errors;
};

class UploadEditForm extends React.Component {
  constructor(props) {
    super(props);
    const { upload, job } = props;
    this.reinitializeForm({ upload, job });
  }

  componentWillReceiveProps({ job, upload }) {
    if (
      (upload && upload.id !== this.props.upload.id) ||
      (job && job.id !== this.props.job.id)
    ) {
      this.reinitializeForm({ upload, job });
    }
  }

  reinitializeForm = ({ upload = {}, job = {} }) => {
    this.props.initialize({
      name: upload.name,
      attachmentType: upload.attachmentType || "OTHER",
      contractNumber: job.contractNumber || "",
      contractAmount: "",
      contractEffectiveDate: moment().toISOString(),
      contractType: job.contractType || ""
    });
  };

  renderContractFields = () => (
    <div>
      <Box width={1} pb={2}>
        <Query
          query={JobContractsQuery}
          variables={{ jobId: this.props.job.id }}
        >
          {({ loading, error, data }) => {
            let status;

            if (loading) status = "Loading...";
            else if (error) status = "Could not load contracts.";
            else if (!data.contracts.length) status = "There are no contracts.";

            let options = [
              ...data.contracts
                .filter(contract => !contract.attachment)
                .map(contract => ({
                  value: contract.id,
                  label: [
                    formatPrice(contract.amountInCents),
                    contract.description
                  ]
                    .filter(v => !!v)
                    .join(" - ")
                })),
              { value: "new", label: "New Contract" }
            ];

            return (
              <Field
                name="contractId"
                labelText="Contract"
                placeholder={
                  status || "Choose a contract to link this attachment to"
                }
                component={InputContainer}
                fieldComponent={Select}
                options={options}
              />
            );
          }}
        </Query>
      </Box>
      {this.props.contractId === "new" && (
        <Fragment>
          <Flex pb={2}>
            <Box width={1 / 2} pr={1}>
              <Field
                name="contractNumber"
                labelText="Contract Number"
                placeholder="e.g., C55555"
                component={InputContainer}
              />
            </Box>
            <Box width={1 / 2} pl={1}>
              <Field
                name="contractAmount"
                labelText="Contract Amount"
                component={InputContainer}
              />
            </Box>
          </Flex>
          <Flex pb={2}>
            <Box width={1 / 2} pr={1}>
              <Field
                name="contractEffectiveDate"
                labelText="Contract Date"
                component={InputContainer}
                fieldComponent={DatePicker}
                utc
              />
            </Box>
            <Box width={1 / 2} pl={1}>
              <Field
                name="contractType"
                labelText="Contract Type"
                placeholder="Select a contract type"
                component={InputContainer}
                fieldComponent={Select}
                options={CONTRACT_TYPES}
              />
            </Box>
          </Flex>
        </Fragment>
      )}
    </div>
  );

  render() {
    const {
      attachmentType,
      dropTypes,
      handleSubmit,
      upload,
      cancel,
      cancelAll,
      onSubmit,
      onSubmitAll,
      valid
    } = this.props;

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <FilePreview
          file={upload.file}
          style={{ display: "block", maxWidth: "40%", margin: "0 auto 16px" }}
        />
        <Box pb={2}>
          <Field name="name" labelText="Name" component={InputContainer} />
        </Box>
        <Box pb={2}>
          <Field
            name="attachmentType"
            labelText="Attachment Type"
            placeholder="Select an attachment type"
            component={InputContainer}
            fieldComponent={Select}
            options={dropTypes}
          />
        </Box>
        {attachmentType === "CONTRACT" && this.renderContractFields()}
        <Flex justify="flex-end">
          <ButtonToolbar>
            {cancelAll && (
              <Button type="button" onClick={cancelAll}>
                Cancel All
              </Button>
            )}
            {cancel && (
              <Button type="button" onClick={cancel}>
                Cancel
              </Button>
            )}
            {onSubmitAll &&
              attachmentType !== "CONTRACT" && (
                <Button type="button" onClick={onSubmitAll}>
                  Upload All
                </Button>
              )}
            <Button type="submit" variant="primary" disabled={!valid}>
              Upload File
            </Button>
          </ButtonToolbar>
        </Flex>
      </form>
    );
  }
}

const formName = "uploadEdit";
const selector = formValueSelector(formName);

const enhance = compose(
  connect(state => ({
    attachmentType: selector(state, "attachmentType"),
    contractId: selector(state, "contractId")
  })),
  reduxForm({
    form: formName,
    validate
  })
);

export default enhance(UploadEditForm);



// WEBPACK FOOTER //
// ./src/components/UploadEditForm.js